var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.996 2.49697C27.996 1.11811 26.8779 0 25.4991 0H2.49697C1.11811 0 0 1.11811 0 2.49697V6.86271H28V2.49697H27.996Z",
    fill: "#4088FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.86328V25.4997C0 26.8785 1.11811 27.9966 2.49697 27.9966H25.4991C26.8779 27.9966 27.996 26.8785 27.996 25.4997V6.86328H0Z",
    fill: "url(#paint0_linear_1002_221)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36987 3.44568C4.36987 2.95182 3.96687 2.54883 3.47301 2.54883C2.97915 2.54883 2.57617 2.95182 2.57617 3.44568C2.57617 3.93955 2.97915 4.34254 3.47301 4.34254C3.96687 4.34254 4.36987 3.9435 4.36987 3.44568Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24096 3.44568C8.24096 2.95182 7.83799 2.54883 7.34413 2.54883C6.85026 2.54883 6.44727 2.95182 6.44727 3.44568C6.44727 3.93955 6.85026 4.34254 7.34413 4.34254C7.83799 4.34254 8.24096 3.9435 8.24096 3.44568Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60513 9.65625H3.06641V16.195H9.60513V9.65625Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1002_221",
    x1: 22.012,
    y1: 30.3986,
    x2: 6.31716,
    y2: 3.21443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49B3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTitleIcon);
export default __webpack_public_path__ + "static/media/project_title_icon.ba2586d7a0c81ae3263317b55ed63ddb.svg";
export { ForwardRef as ReactComponent };